const Table = ({ data }) => {
  return (
    <table class='zui-table'>
      <tbody>
        <tr>
          <th>企业名称</th>
          <th>国标行业门类</th>
          <th>国标行业小类</th>
          <th>注册资本</th>
          <th>登记状态</th>
          <th>企业规模</th>
        </tr>
        {data.map((item) => (
          <tr key={item.企业名称}>
            <td>{item.企业名称}</td>
            <td>{item.国标行业门类}</td>
            <td>{item.国标行业小类}</td>
            <td>{item.注册资本}</td>
            <td>{item.登记状态}</td>
            <td>{item.企业规模}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
